/* eslint-disable react-hooks/exhaustive-deps */
import telegram from "@assets/images/telegram.png";
import whatsapp from "@assets/images/whatsapp.png";
import { Locale } from "@common/constans";
import { ContactEmail, IContactEmail } from '@common/models/ContactEmail';
import { ContactNumber, IContactNumber } from '@common/models/ContactNumber';
import { IPerson, IPerson as ITraveler } from '@common/models/Person';
import { IShareInitializeResponse } from "@common/models/ShareInitializeResponse";
import { ISharingRequest } from "@common/models/SharingRequest";
import { ISharingResponse } from "@common/models/SharingResponse";
import { Dialog } from "@components/general/dialog";
import Button from '@components/general/form/Button';
import PhoneSection from '@components/general/form/PhoneSection';
import TextInput from '@components/general/form/TextInput';
import Icon from '@components/general/Icon';
import { IViewport } from '@config/appConfig';
import { Culture, IValidationError } from '@core/index';
import { IAppState } from '@misc/State';
import Config from '@service/Config';
import Notification from '@service/Notification';
import Translate from '@service/Translate';
import { nameof, validationMessage } from '@utilize/Util';
import { FC, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
interface ISharingProps {
    traveler?: ITraveler;
    show: boolean;
    dataSource?: IPerson[];
    shareInitializeResponse?: IShareInitializeResponse;
    selfSharing?: boolean;
    onSharingClick?: (sharingRequest: ISharingRequest) => Promise<ISharingResponse>;
    onCloseClick: () => void;
}

const Sharing: FC<ISharingProps> = (props) => {
    const mobileTimer = useRef<null | NodeJS.Timeout>(null);
    const emailTimer = useRef<null | NodeJS.Timeout>(null);
    const { show, selfSharing, shareInitializeResponse } = props;
    const dataSource = props.dataSource?.filter(x => x.firstName !== props.traveler?.firstName && x.lastName !== props.traveler?.lastName);
    const { tr } = Translate;
    const { small } = Config.get<IViewport>("viewport");
    const IrLocale = Culture.getLocale(Locale.fa);
    const { width } = useSelector((state: IAppState) => ({ width: state.windowWidth }));
    const [disableSharingMobileBtn, setDisableSharingMobileBtn] = useState<boolean>(false);
    const [disableSharingEmailBtn, setDisableSharingEmailBtn] = useState<boolean>(false);
    const [hasMobileOrEmail, setHasMobileOrEmail] = useState<boolean>(false);
    const [textOfSharingEmailBtn, setTextOfSharingEmailBtn] = useState<any>(tr("btn_send"));
    const [textOfSharingMobileBtn, setTextOfSharingMobileBtn] = useState<any>(tr("btn_send"));
    const [validationError, setValidationError] = useState<IValidationError>();
    const [traveler, setTraveler] = useState<ITraveler>({});
    const [sharingRequest, setSharingRequest] = useState<ISharingRequest>({ traveler, languageCode: shareInitializeResponse?.languageCode, shareByEmail: false, shareBySms: false });

    useEffect(() => {
        if (show && navigator && selfSharing && width <= small) {
            handleOnClick()
            props.onCloseClick();
        }
    }, [show])

    useEffect(() => {
        setTraveler(props.traveler ? { ...props.traveler, email: shareInitializeResponse?.email, mobile: shareInitializeResponse?.mobile } : {})
        setHasMobileOrEmail(shareInitializeResponse?.email || shareInitializeResponse?.mobile ? true : false);
        if (shareInitializeResponse?.mobileTimer && shareInitializeResponse?.mobileTimer > 0) {
            clearInterval(mobileTimer.current as NodeJS.Timeout);
            onSetRemainingTimeOfMobileSharing(shareInitializeResponse.mobileTimer);
        }
        if (shareInitializeResponse?.emailTimer && shareInitializeResponse.emailTimer > 0) {
            clearInterval(emailTimer.current as NodeJS.Timeout);
            onSetRemainingTimeOfEmailSharing(shareInitializeResponse.emailTimer);
        }
    }, [shareInitializeResponse])

    const onContactNumberChange = (name: string, value: any) => {
        const contactNumber: IContactNumber = traveler.mobile || {};
        if (contactNumber.type) {
            contactNumber[name as keyof IContactNumber] = value;
        } else {
            contactNumber.type = "CEL";
            contactNumber[name as keyof IContactNumber] = value;
        }
        traveler.mobile = contactNumber;
        removeValidationError(name, value);
        setTraveler({ ...traveler });
    }

    const handleOnClick = () => {
        navigator
            .share({
                title: "Mahan Air",
                text: shareInitializeResponse?.body
            })
            .then(() => {
                console.log('Successfully shared');
            })
            .catch(error => {
                console.error('Something went wrong sharing the blog', error);
            });
    }

    const formErrorsMessages = {
        emailAddress: {
            required: tr("err_record_required", "email"),
            type: tr("err_email")
        },
        internationalCode: {
            required: tr("err_record_required", "id")
        },
        phoneNumber: {
            required: tr("err_record_required", "number_without_zero"),
            pattern: tr("err_phone_number")
        }
    };


    const validateEmail = () => {
        const email = new ContactEmail(traveler.email || {});
        return email.validate();
    }

    const validatePhoneNumber = () => {
        const mobile = new ContactNumber(traveler.mobile || {});
        return mobile.validate("internationalCode", "phoneNumber");

    }

    const validateContact = () => {
        let error: IValidationError = {};
        if (traveler.email?.emailAddress)
            error = Object.assign(error, validateEmail());
        if (traveler.mobile?.phoneNumber)
            error = Object.assign(error, validatePhoneNumber());
        if (!traveler.email?.emailAddress && !traveler.mobile?.phoneNumber) {
            error = Object.assign(error, validateEmail())
            error = Object.assign(error, validatePhoneNumber());
        }
        return error;
    }

    const onSetRemainingTimeOfEmailSharing = (remainingTime: number) => {
        let duration = remainingTime; // Remaining time base on seconds
        setDisableSharingEmailBtn(true);
        setTextOfSharingEmailBtn(tr("btn_send"));
        let minutes, seconds;
        emailTimer.current = setInterval(() => {
            minutes = Math.floor((duration / 60) % 60);
            seconds = Math.floor(duration % 60);
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            setTextOfSharingEmailBtn(<span className="ltr">{minutes} : {seconds}</span>)
            if (--duration < 0) {
                clearInterval(emailTimer.current as NodeJS.Timeout);
                setDisableSharingEmailBtn(false);
                setTextOfSharingEmailBtn(tr("btn_send"));
            }
        }, 1000)
    }

    const onSetRemainingTimeOfMobileSharing = (remainingTime: number) => {
        let duration = remainingTime; // Remaining time base on seconds
        setDisableSharingMobileBtn(true);
        setTextOfSharingMobileBtn(tr("btn_send"));
        let minutes, seconds;
        mobileTimer.current = setInterval(() => {
            minutes = Math.floor((duration / 60) % 60);
            seconds = Math.floor(duration % 60);
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            setTextOfSharingMobileBtn(<span className="ltr">{minutes} : {seconds}</span>)
            if (--duration < 0) {
                clearInterval(mobileTimer.current as NodeJS.Timeout);
                setDisableSharingMobileBtn(false);
                setTextOfSharingMobileBtn(tr("btn_send"));
            }
        }, 1000)
    }

    const onSharingBtnClick = (): Promise<boolean> => {
        return new Promise((resolve, reject) => {
            const error = validateContact();
            if (Object.keys(error).length) {
                reject();
                return setValidationError({ ...error });
            }
            if (traveler.email?.emailAddress
                && dataSource?.some(x => x.email?.emailAddress === traveler.email?.emailAddress)) {
                reject();
                const findDuplicatedTraveler = dataSource?.find(x => x.email?.emailAddress === traveler.email?.emailAddress);
                return Notification.error(tr("err_contact_duplicate", "email", `${findDuplicatedTraveler?.firstName} ${findDuplicatedTraveler?.lastName}`))
            }
            if (traveler.mobile?.internationalCode && traveler.mobile.phoneNumber &&
                dataSource?.some(x => x.mobile?.internationalCode === traveler.mobile?.internationalCode && x.mobile?.phoneNumber === traveler.mobile?.phoneNumber)) {
                reject();
                const findDuplicatedTraveler = dataSource?.find(x => x.mobile?.internationalCode === traveler.mobile?.internationalCode && x.mobile?.phoneNumber === traveler.mobile?.phoneNumber);
                return Notification.error(tr("err_contact_duplicate", "mobile", `${findDuplicatedTraveler?.firstName} ${findDuplicatedTraveler?.lastName}`))
            }
            setValidationError({});
            sharingRequest.traveler = traveler;
            sharingRequest.shareByEmail = traveler.email?.emailAddress ? true : false;
            sharingRequest.shareBySms = traveler.mobile?.phoneNumber ? true : false;
            setSharingRequest({ ...sharingRequest });
            props.onSharingClick && props.onSharingClick(sharingRequest)
                .then(() => {
                    (traveler.email?.emailAddress && onSetRemainingTimeOfEmailSharing(120));
                    (traveler.mobile?.phoneNumber && onSetRemainingTimeOfMobileSharing(120));
                    setHasMobileOrEmail(true);
                })
                .finally(() => {
                    resolve(true);
                })
        })
    }

    const onSharingEmailBtnClick = (): Promise<boolean> => {
        return new Promise((resolve, reject) => {
            const error = validateEmail() || {};
            if (Object.keys(error).length) {
                reject();
                return setValidationError({ ...error });
            }
            if (dataSource?.find(x => x.email?.emailAddress === traveler.email?.emailAddress)) {
                reject();
                const findDuplicatedTraveler = dataSource?.find(x => x.email?.emailAddress === traveler.email?.emailAddress);
                return Notification.error(tr("err_contact_duplicate", "email", `${findDuplicatedTraveler?.firstName} ${findDuplicatedTraveler?.lastName}`))
            }
            setValidationError({});
            sharingRequest.traveler = traveler;
            sharingRequest.shareByEmail = true;
            sharingRequest.shareBySms = false;
            setSharingRequest({ ...sharingRequest });
            props.onSharingClick && props.onSharingClick(sharingRequest)
                .then(() => {
                    onSetRemainingTimeOfEmailSharing(120);
                })
                .finally(() => {
                    resolve(true)
                })
        })

    }
    const onSharingMobileBtnClick = (): Promise<boolean> => {
        return new Promise((resolve, reject) => {
            const error = validatePhoneNumber() || {};
            if (Object.keys(error).length) {
                reject();
                return setValidationError({ ...error });
            }
            if (dataSource?.filter(x => x.firstName !== traveler.firstName && x.lastName !== traveler.lastName)
                ?.find(x => x.mobile?.internationalCode === traveler.mobile?.internationalCode && x.mobile?.phoneNumber === traveler.mobile?.phoneNumber)) {
                reject();
                const findDuplicatedTraveler = dataSource?.find(x => x.mobile?.internationalCode === traveler.mobile?.internationalCode && x.mobile?.phoneNumber === traveler.mobile?.phoneNumber);
                return Notification.error(tr("err_contact_duplicate", "mobile", `${findDuplicatedTraveler?.firstName} ${findDuplicatedTraveler?.lastName}`))
            }
            setValidationError({});
            sharingRequest.traveler = traveler;
            sharingRequest.shareBySms = true;
            sharingRequest.shareByEmail = false;
            setSharingRequest({ ...sharingRequest });
            props.onSharingClick && props.onSharingClick(sharingRequest)
                .then(() => {
                    onSetRemainingTimeOfMobileSharing(120);
                })
                .finally(() => {
                    resolve(true);
                })
        })
    }

    const copyToClipboard = () => {
        navigator.clipboard.writeText(shareInitializeResponse?.shortenLink || "");
        Notification.success(tr("msg_copy_sharing_link"));
    }

    const removeValidationError = (name: string, value: any) => {
        if (validationError)
            delete validationError[name];
        setValidationError({ ...validationError });
    }

    const error = validationError ? validationMessage(formErrorsMessages, validationError) : {};

    return (
        selfSharing && width <= small ? null :
            <Dialog
                animate="fade"
                show={show}
                style={{ width: 440 }}
                title={tr("sharing_for", `${traveler.firstName} ${traveler.lastName}`)}
                onHiding={() => props.onCloseClick()}
            >
                <div className={`sharing${selfSharing ? " self-sharing" : ""}`}>
                    <div className="phone-email-section">
                        <div className="row flex flex-center spa-2">
                            <div className={`${hasMobileOrEmail ? "col-1-1" : "col-1-2"} col-sm-1-1 ${hasMobileOrEmail ? "flex" : ""}`.trim()}>
                                <PhoneSection
                                    type="phone"
                                    label={tr("mobile")}
                                    dataSource={traveler}
                                    dataMember="mobile"
                                    error={error}
                                    freezeCallingCode={IrLocale.phoneCode}
                                    onChange={onContactNumberChange}
                                    readonlyInternationalCode
                                />
                                {
                                    hasMobileOrEmail ?
                                        <Button
                                            variant="contained"
                                            text={textOfSharingMobileBtn}
                                            width="95px"
                                            height="48px"
                                            color="primary"
                                            className="mr-15"
                                            disabled={disableSharingMobileBtn}
                                            onClickAsync={onSharingMobileBtnClick}
                                        />
                                        : ""
                                }
                            </div>
                            <div className={`${hasMobileOrEmail ? "col-1-1" : "col-1-2"} col-sm-1-1 ${hasMobileOrEmail ? "flex" : ""}`.trim()}>
                                <TextInput
                                    name={nameof<IContactEmail>("emailAddress")}
                                    type="email"
                                    dataSource={traveler?.email || Object.assign(traveler, { email: {} })}
                                    dataMember={nameof<IContactEmail>("emailAddress")}
                                    label={tr("email")}
                                    dir="ltr"
                                    error={error.emailAddress}
                                    onChange={removeValidationError}
                                />
                                {
                                    hasMobileOrEmail ?
                                        <Button
                                            variant="contained"
                                            text={textOfSharingEmailBtn}
                                            width="95px"
                                            height="48px"
                                            color="primary"
                                            className="mr-15"
                                            disabled={disableSharingEmailBtn}
                                            onClickAsync={onSharingEmailBtnClick}
                                        />
                                        : ""
                                }
                            </div>
                        </div>
                        {
                            hasMobileOrEmail ? ""
                                : <div className="row flex justify-end spa-2">
                                    <div className="col-1-3 col-sm-1-2">
                                        <Button
                                            id="sharingButton"
                                            variant="contained"
                                            text={disableSharingMobileBtn ? textOfSharingMobileBtn
                                                : textOfSharingEmailBtn}
                                            color="primary"
                                            className="mb"
                                            height="40px"
                                            disabled={disableSharingMobileBtn || disableSharingEmailBtn}
                                            onClickAsync={onSharingBtnClick}
                                        />
                                    </div>
                                </div>
                        }

                    </div>
                    <div className={`sharing-box row${width <= small && navigator ? " navigator" : ""} spa-0`}>
                        {
                            shareInitializeResponse?.shortenLink ? <>
                                <div className="col-1-auto link">
                                    <Icon size="24px" name="icon-copy" onClick={copyToClipboard} />
                                    <span className="flex flex-center title">{`${tr("sharing_link")}:`}</span>
                                    <a className="sharing-link trim" href={shareInitializeResponse.shortenLink} target="_blank" rel="noopener noreferrer">{shareInitializeResponse?.shortenLink?.replace("http://", "")}</a>
                                </div>
                                <div className="col-1-auto sharing-buttons flex flex-center">
                                    <Icon name="icon-share" size="24px" onClick={handleOnClick} />
                                    <div className="social-networks">
                                        <a
                                            className="icon-social-networks"
                                            href={`https://wa.me/${traveler.mobile?.phoneNumber ? `${traveler.mobile.internationalCode}${traveler.mobile.phoneNumber}` : ""}?text=${encodeURIComponent(shareInitializeResponse.body || "")}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={whatsapp} alt="whatsapp" />
                                        </a>
                                        <a
                                            className="icon-social-networks"
                                            href={`https://t.me/share/url?url=${encodeURIComponent(shareInitializeResponse.body || "")}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={telegram} alt="telegram" />
                                        </a>
                                    </div>
                                </div>
                            </>
                                : ""
                        }
                    </div>
                </div>
            </Dialog>
    )
}

export default Sharing;